import moment from "moment";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "highcharts/modules/heatmap"; // registers automatically

import Card from "react-bootstrap/Card";

export default function HeatmapChart({ data }) {
  if (!data) return;

  const setSource = (data) => {
    if (data.source === "website") return 0;
    if (data.source === "box_office" && data.complimentary === false) return 1;
    if (
      data.source === "box_office" &&
      data.payment_method_type === "cash" &&
      data.complimentary === false
    )
      return 2;
    if (data.source === "box_office" && data.complimentary === true) return 3;
    if (
      data.assignment_type === "individual" &&
      data.complimentary !== true &&
      data.payment_option === "card"
    )
      return 4;
    if (
      data.assignment_type === "individual" &&
      data.complimentary !== true &&
      data.payment_option === "cash"
    )
      return 5;
    if (
      data.assignment_type === "group" &&
      data.complimentary !== true &&
      data.payment_option === "card"
    )
      return 6;
    if (
      data.assignment_type === "group" &&
      data.complimentary !== true &&
      data.payment_option === "cash"
    )
      return 7;
    if (data.assignment_type === "comp") return 8;
  };

  let arr = [];
  data.map((d) =>
    arr.push({
      day: moment(d.processed_at).day(),
      qty: d.ticketCounts,
      source: setSource(d),
    }),
  );

  let formattedArr = [];

  // loop sources
  for (let i = 0; i <= 8; i++) {
    // loop days
    for (let j = 0; j <= 6; j++) {
      let ar = arr.filter((a) => a.day === j);
      let br = ar.filter((b) => b.source === i);
      let sum = br.reduce((total, num) => total + num.qty, 0);
      formattedArr.push([i, j, sum]);
    }
  }

  const options = {
    chart: {
      type: "heatmap",
      marginBottom: 130,
      plotBorderWidth: 1,
      backgroundColor: "none",
      height: 400,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: [
        "Online Card",
        "Box Office Card",
        "Box Office Cash",
        "Box Office Comp",
        "Group 20 Card",
        "Group 20 Cash",
        "Group +20 Card",
        "Group +20 Cash",
        "Group Comp",
      ],
    },

    yAxis: {
      categories: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      title: null,
      reversed: true,
    },

    accessibility: {
      point: {
        descriptionFormat:
          "{(add index 1)}. " +
          "{series.xAxis.categories.(x)} sales " +
          "{series.yAxis.categories.(y)}, {value}.",
      },
    },

    colorAxis: {
      min: 0,
      minColor: "#FFFFFF",
      maxColor: Highcharts.getOptions().colors[0],
    },

    legend: {
      align: "right",
      layout: "vertical",
      margin: 0,
      verticalAlign: "top",
      y: 25,
      symbolHeight: 280,
    },
    tooltip: {
      formatter: function () {
        return (
          `<b>${this.series.xAxis.categories[this.point.x]}</b> sold<br>` +
          `<b>${this.point.value}</b> tickets on <br>` +
          `<b>${this.series.yAxis.categories[this.point.y]}</b>`
        );
      },
    },
    series: [
      {
        name: "Ticket sold per weekday",
        borderWidth: 1,
        data: formattedArr,
        dataLabels: {
          enabled: true,
          color: "#000000",
        },
      },
    ],

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            yAxis: {
              labels: {
                format: "{substr value 0 1}",
              },
            },
          },
        },
      ],
    },
  };

  return (
    <Card body className="card--md card-with-border">
      <div className="card-body-heading card-body-heading--sm">
        <Card.Title as="h5">Channel Performance by Day</Card.Title>
        <Card.Subtitle as="h6" className="mt-2">
          Detailed breakdown showing which channels perform best on specific
          days
        </Card.Subtitle>
      </div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Card>
  );
}
